// import React, { useState } from 'react';
// import { EyeIcon, EyeSlashIcon } from '@heroicons/react/24/outline';
// import FormInput from './FormInput';

// const PasswordField = ({ label, name, value, onChange, onBlur, error, placeholder, required = false }) => {
//   const [showPassword, setShowPassword] = useState(false);

//   return (
//     <div>
//       <label className="block text-sm font-medium text-gray-700 mb-2">
//         {label} {required && <span className="text-red-500">*</span>}
//       </label>
//       <div className="relative">
//         <FormInput
//           name={name}
//           type={showPassword ? 'text' : 'password'}
//           value={value}
//           onChange={onChange}
//           onBlur={onBlur}
//           error={error}
//           placeholder={placeholder}
//           className="pr-10"
//           required={required}
//         />
//         <button
//           type="button"
//           onClick={() => setShowPassword(!showPassword)}
//           className="absolute inset-y-0 right-0 pr-3 flex items-center"
//         >
//           {showPassword ?
//             <EyeSlashIcon className="h-5 w-5 text-gray-400" /> :
//             <EyeIcon className="h-5 w-5 text-gray-400" />
//           }
//         </button>
//       </div>
//     </div>
//   );
// };

// export default PasswordField;
import React, { useState } from "react";
import { EyeIcon, EyeSlashIcon } from "@heroicons/react/24/outline";
import FormInput from "./FormInput";

const PasswordField = ({
  label,
  name,
  value,
  onChange,
  onBlur,
  error,
  placeholder,
  required = false,
  hideLabel = true, // ✅ new prop
}) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div>
      {!hideLabel && label && (
        <label className="block text-sm font-medium text-gray-700 mb-2">
          {label} {required && <span className="text-red-500">*</span>}
        </label>
      )}
      <div className="relative">
        <FormInput name={name} type={showPassword ? "text" : "password"} value={value} onChange={onChange} onBlur={onBlur} error={error} placeholder={placeholder} className="pr-10" required={required} />
        <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute inset-y-0 right-0 pr-3 flex items-center">
          {showPassword ? <EyeSlashIcon className="h-5 w-5 text-gray-400" /> : <EyeIcon className="h-5 w-5 text-gray-400" />}
        </button>
      </div>
    </div>
  );
};

export default PasswordField;
